export default __webpack_public_path__ + "static/media/iDocCarFont.59afae8a.eot";